export function getTypeNameForDebugging(type: any): string {
    return type.name || typeof type;
}
